export enum EDateFormats {
  date = 'MM/dd/yyyy',
  'yyyy-MM-dd' = 'yyyy-MM-dd',
  'yyyy/MM/dd' = 'yyyy/MM/dd',
  'yyyy.MM.dd hh:mm:ss' = 'yyyy.MM.dd hh:mm:ss',
  'yyyyMMddhhmm' = 'yyyyMMddhhmm',
}
